var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgYoutubeLogo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 11"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M15.012 2.168a1.86 1.86 0 0 0-1.313-1.34C12.523.5 7.875.5 7.875.5S3.199.5 2.023.828a1.86 1.86 0 0 0-1.312 1.34C.383 3.316.383 5.778.383 5.778s0 2.433.328 3.609a1.82 1.82 0 0 0 1.312 1.312C3.2 11 7.875 11 7.875 11s4.648 0 5.824-.3a1.82 1.82 0 0 0 1.313-1.313c.328-1.176.328-3.61.328-3.61s0-2.46-.328-3.609M6.344 7.992v-4.43l3.883 2.215z"
})));
export default SvgYoutubeLogo;